import type { Empresa } from '@entregas/core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { atualizarEmpresa, criarEmpresa, marcarLocalDaLoja, obterMinhaEmpresa } from '../empresa';
import type { ErroApi } from '../erros';
import { chaves } from './chaves';
import { useDb } from './contexto';

// Loja do usuário logado (web e app do dono). Erros chegam como ErroApi, já em pt-BR.

export function useMinhaEmpresa(habilitado = true) {
  const db = useDb();
  return useQuery({
    queryKey: chaves.empresa,
    queryFn: () => obterMinhaEmpresa(db),
    enabled: habilitado,
    staleTime: 5 * 60_000,
  });
}

export function useCriarEmpresa() {
  const db = useDb();
  const qc = useQueryClient();
  return useMutation<Empresa, ErroApi, string>({
    mutationFn: (nome) => criarEmpresa(db, nome),
    onSuccess: () => qc.invalidateQueries({ queryKey: chaves.empresa }),
  });
}

export function useAtualizarEmpresa() {
  const db = useDb();
  const qc = useQueryClient();
  return useMutation<
    Empresa,
    ErroApi,
    { id: string; dados: Parameters<typeof atualizarEmpresa>[2] }
  >({
    mutationFn: ({ id, dados }) => atualizarEmpresa(db, id, dados),
    onSuccess: () => qc.invalidateQueries({ queryKey: chaves.empresa }),
  });
}

/** "Estou na loja": marca o local da loja com o GPS deste aparelho (só o dono). */
export function useMarcarLocalDaLoja() {
  const db = useDb();
  const qc = useQueryClient();
  return useMutation<Empresa, ErroApi, Parameters<typeof marcarLocalDaLoja>[1]>({
    mutationFn: (local) => marcarLocalDaLoja(db, local),
    onSuccess: () => qc.invalidateQueries({ queryKey: chaves.empresa }),
  });
}
